<div class="user-area-wrapper">
  <opac-user-title [title]="'searches.title' | translate"></opac-user-title>

  <ng-container *ngIf="(isLoading$ | async) === false">
    <opac-no-results *ngIf="(emptySearches$ | async) === true" [label]="'searches.noSearches' | translate">
      <opac-no-results-results slot="custom-svg"></opac-no-results-results>
      <opac-no-results-cta>
        {{ 'checkouts.browse' | translate }}
        <opac-button type="secondary" (click)="explore()"> {{ 'search.explore' | translate }} </opac-button>
      </opac-no-results-cta>
    </opac-no-results>

    <section *ngIf="(emptySearches$ | async) === false">
      <ng-container *ngIf="searchHistory$ | async as searchesHistory">
        <opac-user-section [title]="'searches.historyTitle' | translate">
          <app-user-search-table [searchesHistory]="searchesHistory" [history]="true"></app-user-search-table>
        </opac-user-section>
      </ng-container>

      <ng-container *ngIf="savedSearches$ | async as savedSearches">
        <div class="table-wrapper" *ngIf="savedSearches.length">
          <h2 class="saved-searches" [tabIndex]="0">{{ 'searches.savedTitle' | translate }}</h2>
          <app-user-search-table [savedSearches]="savedSearches"></app-user-search-table></div
      ></ng-container>
    </section>
  </ng-container>
</div>
